module.exports = __webpack_public_path__ + "img/logo.3481bc7a.png";